import React, { useState } from "react";

const useGuildQAForm = (callback: any, initialState: {}) => {
  const [values, setValues] = useState(initialState) as any;

  const superSetValues = (init: any) => {
    setValues(init);
  };

  // onChange
  const onChange = (event: any, init: any, qaId: any) => {
    // console.log(...init["questionList"]);
    // console.log(qaId);
    // console.log(values);

    const newVal = {
      ...values,
      // eslint-disable-next-line
      ["questionList"]: values["questionList"].map((item: any) => {
        // return item;
        // console.log("questions ", item);
        if (item.id === qaId) {
          return {
            ...item,
            // eslint-disable-next-line
            ["optionList"]: item.optionList.map((inner: any) => {
              if (event.target.value === inner.id) {
                // console.log(inner);
                //   console.log({ ...inner, ["selected"]: true });
                // eslint-disable-next-line
                return { ...inner, ["selected"]: true };
              }
              // eslint-disable-next-line
              return { ...inner, ["selected"]: false };
            }),
          };
        }
        return { ...item };

        // console.log(item);
      }),
    };

    // console.log("values", values);
    // console.log("old val", values);
    // console.log("newVal", newVal);

    setValues({ ...values, ...newVal });
    return false;
  };

  // onSubmit
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await callback(); // triggering the callback
  };

  // return values
  return {
    onChange,
    onSubmit,
    values,
    superSetValues,
  };
};

export default useGuildQAForm;
